export type PowerupType = 'bolt' | 'shield' | 'star';
export type PowerupTier = 'green' | 'blue' | 'yellow' | 'red';

/** Duration a collected buff lasts, in seconds. */
export const BUFF_DURATION = 8;

/** Seconds before an uncollected powerup despawns. */
export const POWERUP_TTL = 30;

/** Recharge-rate / damage multiplier per tier (green < blue < yellow < red). */
export const TIER_MULTIPLIERS: Record<PowerupTier, number> = {
  green:  1.25,
  blue:   1.50,
  yellow: 1.75,
  red:    2.00,
};

/** Glow colour per tier for client rendering. */
export const TIER_COLORS: Record<PowerupTier, number> = {
  green:  0x44ff66,
  blue:   0x44aaff,
  yellow: 0xffdd44,
  red:    0xff4444,
};

/** Cumulative thresholds for weighted tier selection: green 50%, blue 30%, yellow 15%, red 5%. */
const TIER_THRESHOLDS: [PowerupTier, number][] = [
  ['green',  0.50],
  ['blue',   0.80],
  ['yellow', 0.95],
  ['red',    1.00],
];

const TYPES: PowerupType[] = ['bolt', 'shield', 'star'];

export function randomPowerupTier(): PowerupTier {
  const r = Math.random();
  for (const [tier, threshold] of TIER_THRESHOLDS) {
    if (r < threshold) return tier;
  }
  return 'red';
}

export function randomPowerupType(): PowerupType {
  return TYPES[Math.floor(Math.random() * TYPES.length)];
}

/** Atlas frame name for a powerup sprite, e.g. 'powerupGreen_bolt.png'. */
export function powerupFrame(tier: PowerupTier, type: PowerupType): string {
  const t = tier.charAt(0).toUpperCase() + tier.slice(1);
  return `powerup${t}_${type}.png`;
}
